"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _abbadiaLariana = _interopRequireDefault(require("./32_group_2024_09_12/abbadia-lariana"));

var _amantea = _interopRequireDefault(require("./32_group_2024_09_12/amantea"));

var _angera = _interopRequireDefault(require("./32_group_2024_09_12/angera"));

var _arbus = _interopRequireDefault(require("./32_group_2024_09_12/arbus"));

var _arzignano = _interopRequireDefault(require("./32_group_2024_09_12/arzignano"));

var _asti = _interopRequireDefault(require("./32_group_2024_09_12/asti"));

var _ateleta = _interopRequireDefault(require("./32_group_2024_09_12/ateleta"));

var _bardelloConMalgessoEBregano = _interopRequireDefault(require("./32_group_2024_09_12/bardello-con-malgesso-e-bregano"));

var _bellizzi = _interopRequireDefault(require("./32_group_2024_09_12/bellizzi"));

var _belpasso = _interopRequireDefault(require("./32_group_2024_09_12/belpasso"));

var _bosa = _interopRequireDefault(require("./32_group_2024_09_12/bosa"));

var _caldogno = _interopRequireDefault(require("./32_group_2024_09_12/caldogno"));

var _campoSanMartino = _interopRequireDefault(require("./32_group_2024_09_12/campo-san-martino"));

var _campobelloDiMazara = _interopRequireDefault(require("./32_group_2024_09_12/campobello-di-mazara"));

var _campospinosoAlbaredo = _interopRequireDefault(require("./32_group_2024_09_12/campospinoso-albaredo"));

var _carbonera = _interopRequireDefault(require("./32_group_2024_09_12/carbonera"));

var _carlazzo = _interopRequireDefault(require("./32_group_2024_09_12/carlazzo"));

var _castellammareDelGolfo = _interopRequireDefault(require("./32_group_2024_09_12/castellammare-del-golfo"));

var _castellaneta = _interopRequireDefault(require("./32_group_2024_09_12/castellaneta"));

var _castelsardo = _interopRequireDefault(require("./32_group_2024_09_12/castelsardo"));

var _castiadas = _interopRequireDefault(require("./32_group_2024_09_12/castiadas"));

var _cesena = _interopRequireDefault(require("./32_group_2024_09_12/cesena"));

var _cuglieri = _interopRequireDefault(require("./32_group_2024_09_12/cuglieri"));

var _domusDeMaria = _interopRequireDefault(require("./32_group_2024_09_12/domus-de-maria"));

var _erice = _interopRequireDefault(require("./32_group_2024_09_12/erice"));

var _forli = _interopRequireDefault(require("./32_group_2024_09_12/forli"));

var _fossacesia = _interopRequireDefault(require("./32_group_2024_09_12/fossacesia"));

var _gallipoli = _interopRequireDefault(require("./32_group_2024_09_12/gallipoli"));

var _gardoneValTrompia = _interopRequireDefault(require("./32_group_2024_09_12/gardone-val-trompia"));

var _gavardo = _interopRequireDefault(require("./32_group_2024_09_12/gavardo"));

var _lazise = _interopRequireDefault(require("./32_group_2024_09_12/lazise"));

var _leivi = _interopRequireDefault(require("./32_group_2024_09_12/leivi"));

var _lesina = _interopRequireDefault(require("./32_group_2024_09_12/lesina"));

var _lizzano = _interopRequireDefault(require("./32_group_2024_09_12/lizzano"));

var _lonatePozzolo = _interopRequireDefault(require("./32_group_2024_09_12/lonate-pozzolo"));

var _luisago = _interopRequireDefault(require("./32_group_2024_09_12/luisago"));

var _maruggio = _interopRequireDefault(require("./32_group_2024_09_12/maruggio"));

var _massalengo = _interopRequireDefault(require("./32_group_2024_09_12/massalengo"));

var _milano = _interopRequireDefault(require("./32_group_2024_09_12/milano"));

var _montagnaSullaStradaDelVino = _interopRequireDefault(require("./32_group_2024_09_12/montagna-sulla-strada-del-vino"));

var _montecarlo = _interopRequireDefault(require("./32_group_2024_09_12/montecarlo"));

var _montecorice = _interopRequireDefault(require("./32_group_2024_09_12/montecorice"));

var _montecorvinoPugliano = _interopRequireDefault(require("./32_group_2024_09_12/montecorvino-pugliano"));

var _monteneroDiBisaccia = _interopRequireDefault(require("./32_group_2024_09_12/montenero-di-bisaccia"));

var _moransengoTonengo = _interopRequireDefault(require("./32_group_2024_09_12/moransengo-tonengo"));

var _morcianoDiLeuca = _interopRequireDefault(require("./32_group_2024_09_12/morciano-di-leuca"));

var _nervesaDellaBattaglia = _interopRequireDefault(require("./32_group_2024_09_12/nervesa-della-battaglia"));

var _nimis = _interopRequireDefault(require("./32_group_2024_09_12/nimis"));

var _noviDiModena = _interopRequireDefault(require("./32_group_2024_09_12/novi-di-modena"));

var _osiglia = _interopRequireDefault(require("./32_group_2024_09_12/osiglia"));

var _palau = _interopRequireDefault(require("./32_group_2024_09_12/palau"));

var _parma = _interopRequireDefault(require("./32_group_2024_09_12/parma"));

var _pasturo = _interopRequireDefault(require("./32_group_2024_09_12/pasturo"));

var _pianCamuno = _interopRequireDefault(require("./32_group_2024_09_12/pian-camuno"));

var _pievepelago = _interopRequireDefault(require("./32_group_2024_09_12/pievepelago"));

var _pollina = _interopRequireDefault(require("./32_group_2024_09_12/pollina"));

var _ponteDellOlio = _interopRequireDefault(require("./32_group_2024_09_12/ponte-dell-olio"));

var _pontecagnanoFaiano = _interopRequireDefault(require("./32_group_2024_09_12/pontecagnano-faiano"));

var _pornassio = _interopRequireDefault(require("./32_group_2024_09_12/pornassio"));

var _portoValtravaglia = _interopRequireDefault(require("./32_group_2024_09_12/porto-valtravaglia"));

var _poviglio = _interopRequireDefault(require("./32_group_2024_09_12/poviglio"));

var _prataCamportaccio = _interopRequireDefault(require("./32_group_2024_09_12/prata-camportaccio"));

var _pula = _interopRequireDefault(require("./32_group_2024_09_12/pula"));

var _ribera = _interopRequireDefault(require("./32_group_2024_09_12/ribera"));

var _rimini = _interopRequireDefault(require("./32_group_2024_09_12/rimini"));

var _riposto = _interopRequireDefault(require("./32_group_2024_09_12/riposto"));

var _roma = _interopRequireDefault(require("./32_group_2024_09_12/roma"));

var _rometta = _interopRequireDefault(require("./32_group_2024_09_12/rometta"));

var _rovito = _interopRequireDefault(require("./32_group_2024_09_12/rovito"));

var _saglianoMicca = _interopRequireDefault(require("./32_group_2024_09_12/sagliano-micca"));

var _salve = _interopRequireDefault(require("./32_group_2024_09_12/salve"));

var _sanFior = _interopRequireDefault(require("./32_group_2024_09_12/san-fior"));

var _sanGiovanniTeatino = _interopRequireDefault(require("./32_group_2024_09_12/san-giovanni-teatino"));

var _sanMauroPascoli = _interopRequireDefault(require("./32_group_2024_09_12/san-mauro-pascoli"));

var _sanPietroVernotico = _interopRequireDefault(require("./32_group_2024_09_12/san-pietro-vernotico"));

var _sanVitoLoCapo = _interopRequireDefault(require("./32_group_2024_09_12/san-vito-lo-capo"));

var _sannicola = _interopRequireDefault(require("./32_group_2024_09_12/sannicola"));

var _santAntioco = _interopRequireDefault(require("./32_group_2024_09_12/sant-antioco"));

var _santaCaterinaDEste = _interopRequireDefault(require("./32_group_2024_09_12/santa-caterina-d-este"));

var _santaCroceCamerina = _interopRequireDefault(require("./32_group_2024_09_12/santa-croce-camerina"));

var _santaGiustinaInColle = _interopRequireDefault(require("./32_group_2024_09_12/santa-giustina-in-colle"));

var _santaVenerina = _interopRequireDefault(require("./32_group_2024_09_12/santa-venerina"));

var _sarroch = _interopRequireDefault(require("./32_group_2024_09_12/sarroch"));

var _saviano = _interopRequireDefault(require("./32_group_2024_09_12/saviano"));

var _sedico = _interopRequireDefault(require("./32_group_2024_09_12/sedico"));

var _selargius = _interopRequireDefault(require("./32_group_2024_09_12/selargius"));

var _setteville = _interopRequireDefault(require("./32_group_2024_09_12/setteville"));

var _sovizzo = _interopRequireDefault(require("./32_group_2024_09_12/sovizzo"));

var _squillace = _interopRequireDefault(require("./32_group_2024_09_12/squillace"));

var _squinzano = _interopRequireDefault(require("./32_group_2024_09_12/squinzano"));

var _surbo = _interopRequireDefault(require("./32_group_2024_09_12/surbo"));

var _taviano = _interopRequireDefault(require("./32_group_2024_09_12/taviano"));

var _torgiano = _interopRequireDefault(require("./32_group_2024_09_12/torgiano"));

var _torreDelGreco = _interopRequireDefault(require("./32_group_2024_09_12/torre-del-greco"));

var _trebaseleghe = _interopRequireDefault(require("./32_group_2024_09_12/trebaseleghe"));

var _treia = _interopRequireDefault(require("./32_group_2024_09_12/treia"));

var _trepuzzi = _interopRequireDefault(require("./32_group_2024_09_12/trepuzzi"));

var _trinitaDAgultuEVignola = _interopRequireDefault(require("./32_group_2024_09_12/trinita-d-agultu-e-vignola"));

var _uggiateConRonago = _interopRequireDefault(require("./32_group_2024_09_12/uggiate-con-ronago"));

var _valpratoSoana = _interopRequireDefault(require("./32_group_2024_09_12/valprato-soana"));

var _varese = _interopRequireDefault(require("./32_group_2024_09_12/varese"));

var _verrayes = _interopRequireDefault(require("./32_group_2024_09_12/verrayes"));

var _vicoDelGargano = _interopRequireDefault(require("./32_group_2024_09_12/vico-del-gargano"));

var _villanovaDAlbenga = _interopRequireDefault(require("./32_group_2024_09_12/villanova-d-albenga"));

var _zagarolo = _interopRequireDefault(require("./32_group_2024_09_12/zagarolo"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = _objectSpread({}, _abbadiaLariana["default"], {}, _amantea["default"], {}, _angera["default"], {}, _arbus["default"], {}, _arzignano["default"], {}, _asti["default"], {}, _ateleta["default"], {}, _bardelloConMalgessoEBregano["default"], {}, _bellizzi["default"], {}, _belpasso["default"], {}, _bosa["default"], {}, _caldogno["default"], {}, _campoSanMartino["default"], {}, _campobelloDiMazara["default"], {}, _campospinosoAlbaredo["default"], {}, _carbonera["default"], {}, _carlazzo["default"], {}, _castellammareDelGolfo["default"], {}, _castellaneta["default"], {}, _castelsardo["default"], {}, _castiadas["default"], {}, _cesena["default"], {}, _cuglieri["default"], {}, _domusDeMaria["default"], {}, _erice["default"], {}, _forli["default"], {}, _fossacesia["default"], {}, _gallipoli["default"], {}, _gardoneValTrompia["default"], {}, _gavardo["default"], {}, _lazise["default"], {}, _leivi["default"], {}, _lesina["default"], {}, _lizzano["default"], {}, _lonatePozzolo["default"], {}, _luisago["default"], {}, _maruggio["default"], {}, _massalengo["default"], {}, _milano["default"], {}, _montagnaSullaStradaDelVino["default"], {}, _montecarlo["default"], {}, _montecorice["default"], {}, _montecorvinoPugliano["default"], {}, _monteneroDiBisaccia["default"], {}, _moransengoTonengo["default"], {}, _morcianoDiLeuca["default"], {}, _nervesaDellaBattaglia["default"], {}, _nimis["default"], {}, _noviDiModena["default"], {}, _osiglia["default"], {}, _palau["default"], {}, _parma["default"], {}, _pasturo["default"], {}, _pianCamuno["default"], {}, _pievepelago["default"], {}, _pollina["default"], {}, _ponteDellOlio["default"], {}, _pontecagnanoFaiano["default"], {}, _pornassio["default"], {}, _portoValtravaglia["default"], {}, _poviglio["default"], {}, _prataCamportaccio["default"], {}, _pula["default"], {}, _ribera["default"], {}, _rimini["default"], {}, _riposto["default"], {}, _roma["default"], {}, _rometta["default"], {}, _rovito["default"], {}, _saglianoMicca["default"], {}, _salve["default"], {}, _sanFior["default"], {}, _sanGiovanniTeatino["default"], {}, _sanMauroPascoli["default"], {}, _sanPietroVernotico["default"], {}, _sanVitoLoCapo["default"], {}, _sannicola["default"], {}, _santAntioco["default"], {}, _santaCaterinaDEste["default"], {}, _santaCroceCamerina["default"], {}, _santaGiustinaInColle["default"], {}, _santaVenerina["default"], {}, _sarroch["default"], {}, _saviano["default"], {}, _sedico["default"], {}, _selargius["default"], {}, _setteville["default"], {}, _sovizzo["default"], {}, _squillace["default"], {}, _squinzano["default"], {}, _surbo["default"], {}, _taviano["default"], {}, _torgiano["default"], {}, _torreDelGreco["default"], {}, _trebaseleghe["default"], {}, _treia["default"], {}, _trepuzzi["default"], {}, _trinitaDAgultuEVignola["default"], {}, _uggiateConRonago["default"], {}, _valpratoSoana["default"], {}, _varese["default"], {}, _verrayes["default"], {}, _vicoDelGargano["default"], {}, _villanovaDAlbenga["default"], {}, _zagarolo["default"]);

exports["default"] = _default;